import * as Business      from '../business';
import { connect }        from 'react-redux';
import { format }         from 'date-fns';
import { getServiceName } from './reviews';
import { parseISO }       from 'date-fns';
import { subDays }        from 'date-fns';
import calculateScorecard from './calc_scorecard';
import classnames         from 'classnames';
import FetchFromServer    from '../components/fetch_from_server';
import Navbar             from '../components/navbar';
import React              from 'react';



export default connect(
  (state, { businessID }) => ({
    classified: Business.getClassifiedWithMatchReview(state, businessID),
    statuses:   [
      Business.getClassifiedStatuses(state, businessID),
      Business.getReviewsStatuses(state, businessID)
    ]
  }),
  (dispatch, { businessID }) => ({
    load: () => {
      dispatch(Business.readClassified(businessID));
      dispatch(Business.readReviews(businessID));
    }
  })
)(ScorecardPage);


function ScorecardPage({ classified, statuses, load }) {
  return (
    <React.Fragment>
      <Navbar title="Team Scorecard"/>
      <FetchFromServer statuses={statuses} load={load}>
        {classified && (<ScorecardsContainer classified={classified}/>)}
      </FetchFromServer>
    </React.Fragment>
  );
}

class ScorecardsContainer extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state    = { currentSegment: 30 };
    this.onSelect = this.onSelect.bind(this);
  }

  onSelect(segment) {
    return event => {
      event.preventDefault();
      this.setState({
        previousSegment: this.state.currentSegment,
        currentSegment:  segment
      });
    };
  }

  render() {
    const { currentSegment  } = this.state;
    const { previousSegment } = this.state;
    const { classified }      = this.props;

    return (
      <div className="scorecards" >
        <SegmentButtons current={currentSegment} onSelect={this.onSelect}/>
        {[ 30, 60, 90 ].map(days => (
          <Segment
            key={days}
            classified={classified}
            days={days}
            currentSegment={currentSegment}
            previousSegment={previousSegment}/>
        ))}
      </div>
    );
  }
}



function SegmentButtons({ current, onSelect }) {
  return (
    <div className="b-segments__container">
      <div className="segmented">
        {[ 30, 60, 90 ].map(days => (
          <SegmentButton
            key={days}
            segment={days}
            active={current === days}
            onSelect={onSelect(days)}
          />
        ))}
      </div>
    </div>
  );
}


function SegmentButton({ segment, active, onSelect }) {
  const className = classnames('button', { 'button-active': active });
  return (
    <button
      key={segment}
      data-segment={segment}
      className={className}
      onClick={onSelect}>
      {segment} DAYS
    </button>
  );
}

function Segment({ classified, days, currentSegment, previousSegment }) {
  const scorecard = calculateScorecard(filterClassifiedByDays({ classified, days }));
  const animation = currentSegment > previousSegment ? 'scorecard__segment--right-left 500ms' : 'scorecard__segment--left-right 500ms';
  const display   = currentSegment === days ? 'block' : 'none';
  const style     = { animation, display };

  return <ScorecardTable {...scorecard} days={days} style={style}/>;
}

function filterClassifiedByDays({ classified, days }) {
  return classified.filter(({ timestamp }) => new Date(timestamp) > subDays(new Date(), days));
}

export function ScorecardTable({ providers, overall, days, style }) {
  return (
    <div style={style} className="scorecard scorecard__segment block" data-segment={days}>
      <div className="list">
        <ul>
          <li className="scorecard__header">
            <div className="scorecard__header__container row no-gap">
              <div className="col-45">Team Member</div>
              <div className="col-15">Score</div>
              <div className="col-15">Added</div>
              <div className="col-10">
                <i className="scorecard__header__icon--promoter icons8 icons8-thumbs-up"/>
              </div>
              <div className="col-10">
                <i className="scorecard__header__icon--detractor icons8 icons8-thumbs-down"/>
              </div>
              <div className="col-5"> </div>
            </div>
          </li>
          {providers.map((provider, i) => (
            <TeamMember key={i} {...provider}/>
          ))}
          <Overall {...overall}/>
        </ul>
      </div>
    </div>
  );
}


class TeamMember extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state   = { open: false };
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    const { open } = this.state;
    this.setState({ open: !open });
  }

  render() {
    const { open }       = this.state;
    const { activities } = this.props;
    const { name }       = this.props;

    return [
      <MemberItem key="member" {...this.props} open={open} onClick={this.onClick}/>,
      (open && (
        <Activities key="activities" activities={activities} name={name}/>
      ))
    ];
  }
}


function MemberItem({ name, promoterCount, detractorCount, customerCount, satisfactionScore, open, onClick }) {
  return (
    <li className="scorecard__row" onClick={onClick}>
      <a href="#" className="scorecard__row__link item-link">
        <div className="scorecard__row__inner item-inner">
          <div className="scorecard__row__container row no-gap">
            <div className="scorecard__row__name col-45">{name ? name : 'Other'}</div>
            <div className="scorecard__row__score col-15">{satisfactionScore}</div>
            <div className="scorecard__row__customers col-15">{customerCount}</div>
            <div className="scorecard__row__promoters col-10">{promoterCount ? promoterCount : '-'}</div>
            <div className="scorecard__row__detractors col-10">{detractorCount ? detractorCount : '-'}</div>
            <div className="col-5"><i className={`b-accordion-state ${open ? 'b-accordion-state--open' : 'b-accordion-state--closed'}`}/></div>
          </div>
        </div>
      </a>
    </li>
  );
}


function Activities({ activities, name }) {
  return (
    <div className="scorecard-activity list">
      {activities && activities.length > 0 ? (
        activities.map((props, i) => <Activity key={i} {...props}/>)
      ) : (
        <NoActivity name={name}/>
      )}
    </div>
  );
}

function Activity({ customer, promoter, timestamp, feedback, review }) {
  const thumbClassName = classnames(
    'icons8',
    {
      'icons8-thumbs-up':                        promoter,
      'icons8-thumbs-down':                      !promoter,
      'scorecard-activity-row__icon--promoter':  promoter,
      'scorecard-activity-row__icon--detractor': !promoter
    }
  );

  return (
    <div className="scorecard-activity-row row no-gap item-content">
      <div className="col-10"><i className={thumbClassName}/></div>
      <div className="col-75 scorecard-activity-row__title">
        <div className="scorecard-activity-row__title-container">
          <strong>{customer.name.full}</strong>
          <br/>
          would{promoter ? '' : ' not'} recommend
          {review && ` and wrote a ${review.rating} star review on ${getServiceName(review.service)}:`}
        </div>

        {review?.body && (
          <div className="scorecard-activity-row__feedback">&quot;{review.body}&quot;</div>
        )}
        {feedback?.body && (
          <div className="scorecard-activity-row__feedback">&quot;{feedback.body}&quot;</div>
        )}
      </div>
      <div className="col-15 scorecard-activity-row__date">{format(parseISO(timestamp), 'd MMM')}</div>
    </div>
  );
}

function NoActivity({ name = 'Other' }) {
  return (
    <li className="item-content">
      <div className="item-inner">
        <div className="item-text">No activity to show for {name} during this time period</div>
      </div>
    </li>
  );
}


function Overall({ promoterCount, detractorCount, customerCount, satisfactionScore }) {
  return (
    <li className="scorecard__row item-link">
      <div className="scorecard__row__inner item-inner">
        <div className="scorecard__row__container row no-gap">
          <div className="scorecard__row__name col-45">Overall</div>
          <div className="scorecard__row__score col-15">{satisfactionScore}</div>
          <div className="scorecard__row__customers col-15">{customerCount}</div>
          <div className="scorecard__row__promoters col-10">{promoterCount ? promoterCount : '-'}</div>
          <div className="scorecard__row__detractors col-15">{detractorCount ? detractorCount : '-'}</div>
        </div>
      </div>
    </li>
  );
}
